import { TableColumnMeta } from "ds/components/Table/types";

import { ACTIONS_COLUMN_CONFIG, ActionsColumnId, MAX_CELL_WIDTH } from "./globalTable";

export enum ContextColumnId {
  NAME = "name",
  DESCRIPTION = "description",
  ACTIONS = ActionsColumnId.ACTIONS,
}

export const CONTEXTS_COLUMNS_STORAGE_KEY = "environmentAttachedContextsColumnsConfig";

export const CONTEXTS_COLUMNS: Record<ContextColumnId, TableColumnMeta> = {
  [ContextColumnId.NAME]: {
    id: ContextColumnId.NAME,
    title: "Name",
    defaultWidth: 230,
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
  },
  [ContextColumnId.DESCRIPTION]: {
    id: ContextColumnId.DESCRIPTION,
    title: "Description",
    defaultWidth: 200,
    minWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [ContextColumnId.ACTIONS]: ACTIONS_COLUMN_CONFIG,
};
